module.exports = __webpack_public_path__ + "static/img/w_section_1.b03dc28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/w_section_1.jpg
// module id = uR7g
// module chunks = 0